import axios from 'axios';

// ── استفاده از آدرس کامل API ────────────────────────────────────────────
const API_BASE_URL = 'https://fellfell.ir/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true,
  timeout: 30000,
});

// ── Interceptor برای اضافه کردن توکن ──────────────────────────────────
api.interceptors.request.use(
  (config) => {
    const token = document.cookie
      .split('; ')
      .find(row => row.startsWith('auth_token='))
      ?.split('=')[1];

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ── Interceptor برای مدیریت خطاها ──────────────────────────────────────
api.interceptors.response.use(
  (response) => {
    // ── اگر پاسخ از نوع JSON و حاوی داده‌های API باشد ────────────────
    if (response.data && typeof response.data === 'object') {
      // ── برای API‌هایی که مستقیماً آرایه برمی‌گردانند ──────────────
      if (Array.isArray(response.data)) {
        return { 
          ...response, 
          data: { success: true, data: response.data } 
        };
      }
      // ── برای API‌هایی که { success, data } برمی‌گردانند ──────────────
      if (response.data.success !== undefined) {
        return response;
      }
    }
    return response;
  },
  (error) => {
    console.error('🚨 API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });

    if (error.response?.status === 401) {
      document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;